var app = angular.module('leonardo');

var TaskTeaser = function ($window, $compile, $filter, $q, ngDialog, TaskService, AccountUserService, FilterService,
                           $rootScope, $state, VendorService, PermissionService, DynamicFormDataRestService,
                           TemplateService, PropertyService, DynamicFormRestService, AttachmentService, NoteService,
                           TemplateWorkflowService, ConfigThemeService, ApprovalStepService, $timeout, blockUI, AnalyticsService, DynamicFormProviderService, StatsigService, AuthDataService, NotificationService) {
  return {
    restrict: 'A',
    templateUrl: 'views/templates/task/teaser.html',
    link: function (scope, element, attrs) {
      scope.accountUserService = AccountUserService;
      scope.mode = attrs.mode;
      scope.disabled = attrs.disabled;
      scope.taskService = TaskService;
      scope.permissionService = PermissionService;
      scope.templateService = scope.task.type_task == TaskService.TYPE_TASK_WORKFLOW ? TemplateWorkflowService : TemplateService;
      scope.type_trigger = TemplateService.TYPE_TRIGGER;

      scope.openUrlTab = function(url) {
        window.open(url, '_blank');
      };

      scope.isMyApprovals = function () {
        return $state.current.name === 'approvals';
      };

      scope.showTriggerTaskDetail = function () {
        scope.task.getTriggerData().then(function (result) {
          ngDialog.open({
            template: 'views/templates/dialog/task/trigger-detail.html',
            controller: 'TriggerTaskDetailsDialog',
            data: {
              task: result
            }
          });
        });
      };

      scope.initUsers = function () {
        let list_initial = [];
        let list_last = [];
        const vendors = [];
        scope.task.users_assigned = [];
        let first_users = true;
        if (scope.task.account_users_assigned.length >= vendors.length) {
          list_initial = vendors;
          list_last = scope.task.account_users_assigned;
          first_users = false;
        } else {
          list_initial = scope.task.account_users_assigned;
          list_last = vendors;
        }
        angular.forEach(list_initial, function (value) {
          value.is_user = first_users;
          if (scope.task.users_assigned.length < 2) {
            scope.task.users_assigned.push(value);
          }
        });
        angular.forEach(list_last, function (value) {
          value.is_user = !first_users;
          if (scope.task.users_assigned.length < 4) {
            scope.task.users_assigned.push(value);
          }
        });
        const diff = scope.task.account_users_assigned.length + vendors.length - scope.task.users_assigned.length;
        if (diff > 0) {
          scope.task.users_assigned_plus = diff;
        }
      };

      scope.toggleActions = function ($event) {
        angular.element(document).find('.actions').fadeOut();
        if (!element.find('.actions').is(':visible')) {
          angular.forEach(angular.element('.task-teaser ul.actions'), function (value) {
            angular.element(value).fadeOut();
          });
        }
        const right = angular.element(window).width() - (angular.element($event.target).offset().left + angular.element($event.target).width());
        if (right < 190) {element.find('.actions').css({ right: 0 });}
        element.find('.actions').fadeToggle();
        $event.stopPropagation();
      };

      scope.getClasses = function (task) {
        const classes = [];
        if (task && !isNull(task.priority)) {
          switch (task.priority.toString()) {
            case TemplateService.PRIORITY_CRITICAL:
              classes.push('priority-critical');
              break;
            case TemplateService.PRIORITY_NORMAL:
              classes.push('priority-normal');
              break;
            case TemplateService.PRIORITY_MINOR:
              classes.push('priority-minor');
              break;
          }
        }
        return classes;
      };
      // Helper to get the right block instance
      scope.getBlockInstance = function (mode) {
        switch (mode) {
          case 'pending-section':
            return blockUI.instances.get('pending-section');
          case 'cannot-do-section':
            return blockUI.instances.get('cannot-do-section');
          case 'review-pending-section':
            return blockUI.instances.get('review-pending-section');
          case 'review-revision-section':
            return blockUI.instances.get('review-revision-section');
          case 'review-rejected-section':
            return blockUI.instances.get('review-rejected-section');
          case 'completed-section':
            return blockUI.instances.get('completed-section');
          case 'workspace-section':
            return blockUI.instances.get('workspace-section');
          case 'workflow-section': 
            return blockUI.instances.get('workflow-section');
          case 'monthly-section':
            return blockUI.instances.get('monthly-section');
          case 'weekly-section':
            return blockUI.instances.get('weekly-section');
          case 'daily-section':
            return blockUI.instances.get('daily-section');
          case 'document-section':
            return blockUI.instances.get('document-section');
          default:
            return null;
        }
      }

      angular.element($window).click(function ($event) {
        const $c = element.find('.actions');
        if ($event.target == $c[0] || $c.find($event.target).size() > 0) {
          return false;
        }
        element.find('.actions').fadeOut();
      });

      scope.showUnCompleteDialog = function (task) {
        ngDialog.open({
          template: 'views/templates/dialog/task/uncomplete.html',
          controller: 'TaskUnCompleteDialog',
          data: {
            task: task
          }
        });
      };

      scope.openPDFFile = function (task) {
        var url = task.pdf_file_signed || task.pdf_file;
        if(url){
          window.open(url, '_blank');
          AnalyticsService.track('Completed Dynamic Form Downloaded', {...AnalyticsService.getTaskGroupProperties(task)});
        }
      }

      scope.regeneratingPdf = false;
      scope.regeneratePdf = function (task) {
        if (scope.regeneratingPdf) return;
        var dfdId = task.dynamic_form_data && task.dynamic_form_data.id
          ? task.dynamic_form_data.id
          : task.dynamic_form_data;
        if (!dfdId) return;

        scope.regeneratingPdf = true;
        DynamicFormDataRestService.regeneratePdf(dfdId).then(function () {
          NotificationService.notify('success', 'A new PDF download link is being generated. Please refresh this page shortly to download the updated PDF.');
        }, function (error) {
          NotificationService.error(error);
        }).finally(function () {
          scope.regeneratingPdf = false;
        });
      };

      scope.showUsersDialog = function (task) {
        ngDialog.open({
          template: 'views/templates/dialog/task/users.html',
          controller: 'TaskUsersDialog',
          data: {
            task: task
          }
        });
      };

      scope.showEditTemplate = function (task) {
        scope.templateService.get(task.template).then(function (data) {
          ngDialog
            .openConfirm({
              template: 'views/templates/dialog/template/form.html',
              className: 'ngdialog-theme-default ngdialog-template-edit',
              controller: 'TemplateFormDialog',
              data: {
                template: data
              }
            })
            .then(function () {
              $rootScope.$broadcast('template:updated', task);
            });
        });
      };

      scope.showMoreAppDialog = function () {
        ngDialog.open({
          template: 'views/templates/dialog/task/more-app.html',
          className: 'ngdialog-theme-default ngdialog-iframe',
          controller: 'TaskMoreAppDialog',
          data: {
            url: 'https://webclient.moreapp.com/#/form/566f1d2be4b0e20074af2dd8'
          }
        });
      };

      scope.showResolveDialog = function (task) {
        AnalyticsService.track('Task Opened', {
          context: $state.current.name,
          destination: 'complete',
          entry_method: 'click',
          ...AnalyticsService.getTaskGroupProperties(task)});
        var blockInstance = scope.getBlockInstance(attrs.blockUiMode);
        if (scope.mode === 'document') {
          if (blockInstance) {
            blockInstance.stop();
          }
          let name = '';
          angular.forEach(task.attachments, function (value) {
            name = value.name;
          });
          ngDialog.openConfirm({
            template: 'views/templates/dialog/folder-file/resolve-document-file.html',
            controller: 'TaskResolveDocumentFileDialog',
            resolve: {
              folder: ['FolderService', function (FolderService) {
                return null;
              }]
            },
            data: {
              entity: null,
              task: task,
              name: name
            }
          }).then(function (data_result) {
            $rootScope.$broadcast('task-resolve-dialog:success', data_result.data);
          });
        }
        else {
          var filters = {};
          if (!isNull(scope.task.status) && [
            TaskService.STATUS_APPROVAL_IN_PROGRESS,
            TaskService.STATUS_APPROVAL_APPROVED,
            TaskService.STATUS_APPROVAL_REJECTED
          ].includes(scope.task.status.toString()) && (scope.mode === 'review')) {
            filters.for_approval = true;
          }
          TaskService.one(task.id).get(filters).then(function (result) {
            var promises = [];
            var notes = [];
            angular.forEach(task.notes, function (note) {
              if (note.id) {
                promises.push(notes.push(note));
              } else {
                promises.push(
                  NoteService.get(note, true).then(function (data) {
                    notes.push(data);
                  })
                );
              }
            });
            $q.all(promises).then(function () {
              const newTask = angular.copy(result);
              newTask.notes = notes;
              if (newTask.has_approval_config && ![TaskService.STATUS_APPROVAL_APPROVED].includes(newTask.status.toString())) {
                TaskService.getSequenceApprovers(newTask.id).then(function (conflicts) {
                  if (blockInstance) {
                    blockInstance.stop();
                  }
                  if (!isEmpty(conflicts.results)) {
                    ngDialog.openConfirm({
                      template: 'views/templates/dialog/task/resolve-conflicts.html',
                      controller: 'TaskResolveConflictsDialog',
                      data: {
                        task: newTask,
                        conflicts: conflicts.results
                      }
                    }).then(function (data) {
                      $timeout(function () {
                        ngDialog.open({
                          template: 'views/templates/dialog/task/request-approval.html',
                          controller: 'TaskResolveDialog',
                          data: {
                            task: newTask,
                            fallback_approvers: data,
                          }
                        });
                      }, 200);
                    });
                  }
                  else {
                    ngDialog.open({
                      template: 'views/templates/dialog/task/request-approval.html',
                      controller: 'TaskResolveDialog',
                      data: {
                        task: newTask,
                      }
                    });
                  }
                });
              }
              else {
                if (blockInstance) {
                  blockInstance.stop();
                }
                ngDialog.open({
                  template: 'views/templates/dialog/task/resolve.html',
                  controller: 'TaskResolveDialog',
                  data: {
                    task: newTask
                  }
                });
              }
            }).catch(function () {
              if (blockInstance) {
                blockInstance.stop();
              }
            });
          }).catch(function () {
            if (blockInstance) {
              blockInstance.stop();
            }
          });
        }
      };

      scope.showDetailDialog = function(task) {
        AnalyticsService.track('Task Opened', {
          context: $state.current.name,
          destination: 'detail',
          entry_method: 'click',
          ...AnalyticsService.getTaskGroupProperties(task)});
        ngDialog.openConfirm({
          template: 'views/templates/dialog/task/detail.html',
          controller: 'TaskDetailDialog',
          data: {
            task: task,
            mode: scope.mode,
            ismyapproval: scope.isMyApprovals()
          }
        }).then(function(data) {
          if (data === 'resolve') {
            scope.showDynamicAndResolve(task);
          }
        });
      };

      scope.showRecurrenceDialog = function (task) {
        scope.templateService.get(task.template).then(function (data) {
          const newTask = angular.copy(task);
          newTask.recurrence_type = data.recurrence_type;
          newTask.recurrence = data.recurrence;
          ngDialog.openConfirm({
            template: 'views/templates/dialog/task/recurrence.html',
            controller: 'TaskRecurrenceDialog',
            data: {
              task: newTask,
              template: data
            }
          })
          .then(function () {
            // This is intentional do_something blank function
          });
        });
      };

      scope.showPriorityDialog = function (task) {
        scope.templateService.get(task.template).then(function (data) {
          ngDialog.open({
            template: 'views/templates/dialog/task/priority.html',
            controller: 'TaskPriorityDialog',
            data: {
              task: task,
              template: data
            }
          });
        });
      };

      scope.showDeactivateDialog = function (task) {
        scope.templateService.get(task.template).then(function (data) {
          ngDialog.open({
            template: 'views/templates/dialog/task/deactivate.html',
            controller: 'TaskDeactivateDialog',
            data: {
              task: task,
              template: data
            }
          });
        });
      };

      scope.showCannotDoDialog = function (task) {
        AnalyticsService.track('Task Opened', {
          context: $state.current.name,
          destination: 'cannot do',
          entry_method: 'click',
          ...AnalyticsService.getTaskGroupProperties(task)});
        ngDialog.open({
          template: 'views/templates/dialog/task/cannot-do.html',
          controller: 'TaskCannotDoDialog',
          data: {
            task: task
          }
        });
      };

      scope.showDismissDialog = function (task) {
        ngDialog
          .openConfirm({
            template: 'views/templates/dialog/task/dismiss.html',
            controller: 'TaskDismissDialog',
            data: { task: task }
          })
          .then(function (task) {
            scope.task = task;
            $rootScope.$broadcast('task-cannot-do-dialog:success', task);
          });
      };

      scope.showSnoozeDialog = function (task) {
        ngDialog.open({
          template: 'views/templates/dialog/task/snooze.html',
          controller: 'TaskSnoozeDialog',
          data: { task: task }
        });
      };

      scope.showAttachmentDialog = function (task) {
        const promises = [];
        const attachments = [];
        angular.forEach(task.attachments, function (attachment) {
          promises.push(
            AttachmentService.get(attachment, true).then(function (data) {
              attachments.push(data);
            })
          );
        });
        $q.all(promises).then(function () {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: attachments
            }
          });
        });
      };

      scope.showAttachmentCompletedDialog = function (task) {
        if (scope.mode === 'completed' && task.document_file_resolved) {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: [task.document_file_resolved]
            }
          });
        }
      };

      scope.showAssignVendorDialog = function (task) {
        scope.templateService.get(task.template).then(function (data) {
          ngDialog
            .openConfirm({
              template: 'views/templates/dialog/task/assign-vendors.html',
              controller: 'TaskAssignVendorsDialog',
              data: {
                task: task,
                template: data
              }
            })
            .then(function (result) {
              scope.task = result;
              $rootScope.$broadcast('task-assign-user:updated', scope.task);
            });
        });
      };

      scope.showAssignDialog = function (task) {
        if (task.template) {
          scope.templateService.get(task.template).then(function (template) {
            openAssignDialog(template);
          });
        }
        else {
          openAssignDialog();
        }
        function openAssignDialog(template) {
          ngDialog
            .openConfirm({
              template: 'views/templates/dialog/task/assign.html',
              controller: 'TaskAssignDialog',
              resolve: {
                accountUsers: function () {
                  let filters = {
                    disable_pagination: true,
                    essential: true,
                    user_is_active: true
                  };
                  if (!isEmpty(task.roles)) {
                    filters['role'] = task.roles.join(',');
                  }
                  if (task.property) {
                    filters['property'] = task.property;
                  } else if (task.portfolio) {
                    filters['portfolio'] = task.portfolios;
                  } else if (task.account) {
                    filters['account'] = task.account;
                  }
                  return AccountUserService.getAvailableToAssign(filters);
                }
              },
              data: {
                task: task,
                template: template
              }
            })
            .then(function (result) {
              if (result) {
                scope.task = result;
                $rootScope.$broadcast('task-assign-user:updated', scope.task);
              } else {
                $rootScope.$broadcast('template:updated', scope.task);
              }
            });
        }
      };

      scope.editStepsDialog = function (task) {
        ngDialog.openConfirm({
          template: 'views/templates/dialog/task/editSteps.html',
          className: 'ngdialog-theme-default ngdialog-template-edit',
          controller: 'EditStepsDialog',
          data: {
            task: task,
          }
        }).then(function(){
          $rootScope.$broadcast('template:updated', task);
        }, function(){
          $rootScope.$broadcast('template:updated', task);
        });
      };

      scope.showAssignTemplateDialog = function (task) {
        scope.templateService.get(task.template).then(function (data) {
          ngDialog
            .openConfirm({
              template: 'views/templates/dialog/task/assign.html',
              controller: 'TaskAssignDialog',
              resolve: {
                accountUsers: function () {
                  const filters = {
                    disable_pagination: true,
                    essential: true,
                    user_is_active: true
                  };
                  if (!isEmpty(task.roles)) {
                    filters['role'] = task.roles.join(',');
                  }
                  if (task.property) {
                    filters['property'] = task.property;
                  } else if (task.portfolio) {
                    filters['portfolio'] = task.portfolios;
                  } else if (task.account) {
                    filters['account'] = task.account;
                  }
                  return AccountUserService.getAvailableToAssign(filters);
                }
              },
              data: {
                task: task,
                template: data,
                action: 'template'
              }
            })
            .then(function () {
              $rootScope.$broadcast('template:updated', scope.task);
            });
        });
      };

      scope.showAddNoteDialog = function (task) {
        ngDialog
          .openConfirm({
            template: 'views/templates/dialog/task/add-note.html',
            controller: 'TaskAddNoteDialog',
            data: {
              task: task
            }
          })
          .then(function (data) {
            scope.task.notes.push(data.id);
            $rootScope.$broadcast('task-notes:updated', scope.task);
          });
      };

      scope.showNoteDialog = function (task) {
        const promises = [];
        const notes = [];
        angular.forEach(task.notes, function (note) {
          if (note.id) {
            promises.push(notes.push(note));
          } else {
            promises.push(
              NoteService.get(note, true).then(function (data) {
                notes.push(data);
              })
            );
          }
        });
        $q.all(promises).then(function () {
          const newTask = angular.copy(task);
          newTask.notes = notes;
          ngDialog
            .openConfirm({
              template: 'views/templates/dialog/task/note.html',
              controller: 'TaskNoteDialog',
              data: {
                task: newTask
              }
            })
            .then(function (data) {
              scope.task.notes = data.notes;
            });
        });
      };

      scope.showProperty = function () {
        return ($state.current.name === 'approvals') && !FilterService.hasFilter('property_reports');
      };

      scope.isReview = function () {
        return [
          TaskService.STATUS_APPROVAL_IN_PROGRESS,
          TaskService.STATUS_APPROVAL_REJECTED,
          TaskService.STATUS_APPROVAL_APPROVED,
          TaskService.STATUS_APPROVAL_RETURN_SUBMITTER
        ].includes(scope.task.status.toString());
      }

      scope.isApprover = function () {
        if (PermissionService.isOwner()) return true;
        var current_user = AccountUserService.currentAccountUser.user;
        var approver = false;
        if (scope.task.next_approvers) {
          angular.forEach(scope.task.next_approvers, function (user) {
            if (current_user.id === user.id) {
              approver = true;
            }
          })
        }
        return approver;
      }

      scope.showEditDF = function () {
        if ([
          TaskService.STATUS_APPROVAL_IN_PROGRESS,
          TaskService.STATUS_APPROVAL_APPROVED,
          TaskService.STATUS_APPROVAL_REJECTED,
        ].includes(scope.task.status.toString())) {
          return scope.isApprover();
        }
        return scope.task.editable;
      }

      scope.showDynamicAndResolve = function (task) {
        var blockInstance = scope.getBlockInstance(attrs.blockUiMode);
        if (blockInstance) {
          blockInstance.start();
        }
        if (task.dynamic_form) {
          scope.openDynamicFormDialog(task, function (result) {
            var filters = {};
            if (!isNull(scope.task.status) && [
              TaskService.STATUS_APPROVAL_IN_PROGRESS,
              TaskService.STATUS_APPROVAL_APPROVED,
              TaskService.STATUS_APPROVAL_REJECTED,
              TaskService.STATUS_APPROVAL_RETURN_SUBMITTER,
            ].includes(scope.task.status.toString()) && (scope.mode === 'review')) {
              filters.for_approval = true;
            }
            
            var data = result.dynamic_form_data ? result.dynamic_form_data : result;
            var action_item = result.task ? TaskService.one(result.task).get(filters) : task;
            $q.when(action_item).then(function (result) {
              if (data !== 'skip') {
                scope.task.dynamic_form_data = data.id ? data.id : data;
                if (!data.progress) {
                  scope.showResolveDialog(result);
                }
              }
              else {
                scope.showResolveDialog(result);
              }
            });
          }, true);
        }
        else {
          scope.showResolveDialog(task);
        }
      };

      scope.showDynamicForm = function (task) {
        let taskAux = angular.copy(task);
        taskAux.status = TaskService.STATUS_SOLVED;
        scope.openDynamicFormDialog(taskAux);
      };

            
      /**
       * Opens a dynamic form dialog using DynamicFormProvider to handle Expo/React forms
       * @param {Object} formObj - The form template object
       * @param {Object|null} formDataObj - The form data object (null for new forms)
       * @param {Object} task - The task object
       * @param {Object} property - The property object
       * @param {boolean} showSkipButton - Whether to show skip button
       * @param {Object} filters - Filters to apply
       * @param {Function} callback - Callback function to execute on completion
       */
      scope.openFormDialog = async function(formObj, formDataObj, task, property, showSkipButton, filters, callback) {

        let useExpoIntegration = false;
        let workOrdersEnabled = false;
      
        try {
          // Check if we're in an iframe
          var inIframe = false;
          try {
            inIframe = window.self !== window.top;
          } catch (e) {
            inIframe = true;
          }

          useExpoIntegration = inIframe ? true : await StatsigService.checkGate('envoy_dynamic_forms', { dynamic_form_id: formObj.id });
          workOrdersEnabled = await StatsigService.checkGate('df_work_orders', { dynamic_form_id: formObj.id });

          // ✅ ACTIVATE CONTEXTUAL GATE when user enters the flow
          if (!inIframe && useExpoIntegration) {
            StatsigService.activateContextualGate('envoy_dynamic_forms');
          }
        } catch (error) {
          console.error('[openFormDialog] Failed to check feature gate:', error);
        }

        // ✅ TRACK EVENT when user enters the flow
        AnalyticsService.track('Task Opened', {
          context: $state.current.name,
          destination: 'dynamic_forms',
          entry_method: 'click',
          ...AnalyticsService.getTaskGroupProperties(task)
        });
        
        // Use DynamicFormProvider for centralized form handling
        DynamicFormProviderService.openForm({
          useExpoIntegration: useExpoIntegration,
          workOrdersEnabled: workOrdersEnabled,
          formObj: formObj,
          formDataObj: formDataObj,
          data: {
            task: task,
            approvalStatus: [TaskService.STATUS_APPROVAL_IN_PROGRESS].includes(task.status.toString()),
            property: property,
            showSkip: showSkipButton,
            filters: filters
          },
          closeCallback: function(result) {
            // ✅ DEACTIVATE CONTEXTUAL GATE when form closes
            StatsigService.deactivateContextualGate('envoy_dynamic_forms');
            
            if (result === 'skip') {
              $rootScope.$broadcast('task-dynamic-form-data:updated', scope.task);
              if (callback) {
                callback('skip');
              }
            } else {
              $rootScope.$broadcast('task-dynamic-form-data:updated', scope.task);
              if (callback && !isNull(scope.task.status) && ![
                TaskService.STATUS_APPROVAL_IN_PROGRESS,
                TaskService.STATUS_APPROVAL_APPROVED,
                TaskService.STATUS_APPROVAL_REJECTED,
              ].includes(scope.task.status.toString())) {
                callback(result);
              }
            }
          }
        }).catch(function(error) {
          // ✅ DEACTIVATE CONTEXTUAL GATE on error/cancel
          StatsigService.deactivateContextualGate('envoy_dynamic_forms');
          
          // Handle any errors that weren't handled by the provider
          if (task && task.workflow_instance) {
            $rootScope.$broadcast('close-unit-dynamic-form');
          } else {
            $rootScope.$broadcast('task-dynamic-form-data:updated', scope.task);
          }
        });
      };
      
      scope.openDynamicFormDialog = function (task, callback, showSkipButton) {
        var filters = {};
        if (!isNull(scope.task.status) && [
          TaskService.STATUS_APPROVAL_IN_PROGRESS,
          TaskService.STATUS_APPROVAL_APPROVED,
          TaskService.STATUS_APPROVAL_REJECTED,
          TaskService.STATUS_APPROVAL_RETURN_SUBMITTER
        ].includes(scope.task.status.toString()) && (scope.mode === 'review')) {
          filters.for_approval = true;
        }

        // Get the appropriate block instance
        var blockInstance = scope.getBlockInstance(attrs.blockUiMode);
        
        PropertyService.one(task.property).get(filters).then(function (property) {
          if (task.dynamic_form_data && (task.dynamic_form_data !== 'skip')) {
            var data_id = task.dynamic_form_data.id ? task.dynamic_form_data.id : task.dynamic_form_data;
            DynamicFormDataRestService.one(data_id).get(filters).then(function (data) {
              // Stop the block UI before opening dialog
              if (blockInstance) {
                blockInstance.stop();
              }
              
              // Use the shared function to open the appropriate dialog
              scope.openFormDialog(
                data.dynamic_form,
                data,
                task,
                property,
                showSkipButton,
                filters,
                callback
              );
            });
          }
          else {
            DynamicFormRestService.one(task.dynamic_form).get(filters).then(function (data) {
              // Stop the block UI before opening dialog
              if (blockInstance) {
                blockInstance.stop();
              }
              
              // Use the shared function to open the appropriate dialog
              scope.openFormDialog(
                data,
                null,
                task,
                property,
                showSkipButton,
                filters,
                callback
              );
            });
          }
        }).catch(function (error) {
          if (blockInstance) {
            blockInstance.stop();
          }
        });
      };

      scope.playTask = function () {
        scope.task.play().then(function (data) {
          scope.task.workflow_status = data.workflow_status;
          $rootScope.$broadcast('task-workflow-status:updated', data);
        });
      };

      scope.pauseTask = function () {
        scope.task.pause().then(function (data) {
          scope.task.workflow_status = data.workflow_status;
          $rootScope.$broadcast('task-workflow-status:updated', data);
        });
      };

      scope.resolveTask = function () {
        scope.task.resolveTask().then(function (data) {
          const result = data.data ? data.data : data;
          scope.task.workflow_status = result.workflow_status;
          $rootScope.$broadcast('task-workflow-status:updated', result);
        });
      };

      scope.getDevice = function (type) {
        if (!isNull(type)) {
          switch (type.toString()) {
            case TaskService.DEVICE_TYPE_DESKTOP:
              return 'icon-computer.svg';
            case TaskService.DEVICE_TYPE_IOS:
              return 'icon-apple.svg';
            case TaskService.DEVICE_TYPE_ANDROID:
              return 'icon-android.svg';
          }
        }
        return 'icon-computer.svg';
      };

      scope.isSnoozable = TaskService.taskIsSnoozable;

      scope.isCategoryCode = function (task) {
        return task.category && task.category.toString() === TaskService.CATEGORY_CODE;
      };

      scope.getCurrentStep = function (task) {
        let current_tep = null;
        if (!isEmpty(task.approval_sequences)) {
          angular.forEach(task.approval_sequences, function (sequence) {
            if (sequence.id === task.current_sequence) {
              angular.forEach(sequence.approval_steps, function (step) {
                if (step.status && step.status.toString() === ApprovalStepService.STATUS_IN_PROGRESS) {
                  current_tep = step;
                }
              });
            }
          });
        }
        return current_tep;
      };

      scope.getCurrentStepIndex = function (task) {
        let sequence_steps = 0;
        let current_tep = scope.getCurrentStep(task);
        if (!isEmpty(task.approval_sequences)) {
          angular.forEach(task.approval_sequences, function (sequence) {
            if (sequence.id === task.current_sequence) {
              sequence_steps = sequence.approval_steps.length;
            }
          });
        }
        return current_tep ? current_tep.index + ' ' + $filter('translate')('of') + ' ' + sequence_steps : ' - ';
      };

      scope.showApprovalDate = function (task) {
        return !isNull(task.status) && ([TaskService.STATUS_APPROVAL_IN_PROGRESS, TaskService.STATUS_APPROVAL_APPROVED].includes(task.status.toString()))
          && (scope.mode === 'review');
      };

      scope.getCurrentStepDate = function (task) {
        let current_step = scope.getCurrentStep(task);
        return current_step ? current_step.due_date : task.due_date;
      };

      scope.isPastDue = function(task){
        let due_date = scope.getCurrentStepDate(task);
        return new Date(due_date) < new Date()
      };

      scope.goToReview = function (task) {
        $rootScope.$broadcast('no_reset_filters:updated', true);
        $state.go('property.tasks.approval', {pk:task.id, workflow: task.workflow_instance?.workflow});
      };

      scope.$watch('task.account_users_assigned', function(){
        if (!scope.disabled) {
          scope.initUsers();
        }
      });

      scope.$watch('task.vendors', function () {
        if (!scope.disabled) {
          scope.initUsers();
        }
      });

      if (!scope.disabled) {
        scope.initUsers();
      }

      scope.$watch(
        function () {
          return element.attr('class');
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue) {
            scope.setColor();
          }
        }
      );

      scope.setColor = function () {
        let color = ConfigThemeService.getColor('errorColor');
        scope.classes = element.attr('class');
        if (scope.classes.includes('priority-normal')) {
          color = ConfigThemeService.getColor('warningColor');
        } else if (scope.classes.includes('priority-minor')) {
          color = ConfigThemeService.getColor('tertiaryColor');
        }
        element.css('border-color', color);
      };

      scope.setColor();

      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('taskTeaser', ['$window', '$compile', '$filter', '$q', 'ngDialog', 'TaskService', 'AccountUserService',
  'FilterService', '$rootScope', '$state', 'VendorService', 'PermissionService', 'DynamicFormDataRestService',
  'TemplateService', 'PropertyService', 'DynamicFormRestService', 'AttachmentService', 'NoteService',
  'TemplateWorkflowService', 'ConfigThemeService', 'ApprovalStepService', '$timeout', 'blockUI', 'AnalyticsService', 'DynamicFormProviderService', 'StatsigService', 
  'AuthDataService', 'NotificationService', TaskTeaser]);
